module.exports = __webpack_public_path__ + "img/toolPic1.97c2073a.png";